var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagKuwait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_7777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.9175 50.5435C74.4249 46.4811 75.25 42.0871 75.25 37.5001C75.25 32.9131 74.4249 28.5191 72.9175 24.4567L37.75 21.1958L2.58247 24.4567C1.07515 28.5191 0.25 32.9131 0.25 37.5001C0.25 42.0871 1.07515 46.4811 2.58247 50.5435L37.75 53.8044L72.9175 50.5435Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7502 75C53.8737 75 67.6192 64.8235 72.9176 50.5435H2.58252C7.88115 64.8235 21.6264 75 37.7502 75Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7502 0C21.6264 0 7.88115 10.1766 2.58252 24.4566H72.9177C67.6192 10.1766 53.8737 0 37.7502 0Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2335 10.9834C-3.41116 25.628 -3.41116 49.3718 11.2335 64.0166C15.056 60.1941 18.7869 56.4631 24.7065 50.5435V24.4566L11.2335 10.9834Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_7777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagKuwait);
export default __webpack_public_path__ + "static/media/flagKuwait.5e84ca43493ec88f430ce343991d2198.svg";
export { ForwardRef as ReactComponent };